module.exports = __webpack_public_path__ + "static/media/tiny.f678f36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tiny.png
// module id = 72
// module chunks = 0